import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxEchartsModule } from "ngx-echarts";
import { SharedModule } from "../../../../shared/shared.module";
import { MaterialModule } from "../../../../shared/material.module";
import { SegyViewerComponent } from "./segy-viewer.component";
import { GatherViewerComponent } from "../gather-viewer/gather-viewer.component";

@NgModule({
  declarations: [
    SegyViewerComponent,
    GatherViewerComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    NgxEchartsModule,
  ],
})
export class SegyViewerModule {}
